import { uniqueId } from 'lodash';
import React, { useRef, useState } from 'react';
import { SavedOrder } from '../../../app/domain/Order/SavedOrder';
import { getValidThumbUrl } from '../../../app/domain/Product/Product';
import { formatDate } from '../../util/formatDate';

// Styles
import styles from './SavedOrdersSummary.module.css';

interface Props {
  className: string;
  onOrderClick: Function;
  orders: SavedOrder[];
  cadworxSessionId?: string;
}

const SavedOrdersSummary = (props: Props) => {
  const orders = props.orders;
  const [invalidIds, setInvalidIds] = useState([]);
  const img: any = useRef([]);
  const thumbRef: any = useRef([]);

  function hideDivById(id) {
    if (!invalidIds.includes(id))
      setInvalidIds(invalidIds => [...invalidIds, id]);
  }

  function checkInvalidId(id) {
    return invalidIds.indexOf(id) > -1 ? "none" : "";
  }

  function handleOnLoad(e, id) {
    const thumbElementId = document.getElementById(id).id;
    const imgElement = e.target;
    imgElement.style.display = "flex";
    const nodeList = imgElement.parentElement.childNodes;
    const childElements = nodeList && Array.prototype.slice.call(nodeList);

    if (thumbElementId && childElements?.length > 0) {
      const thumb = childElements.find((x) => x?.id && x.id === thumbElementId);
      thumb.style.display = 'none';
    }
  }

  function getDocThumb(id) {
    const thumbSize = 260;
    const requestModel = {
      Doc: { Id: id },
      Format: 'png',
      Height: thumbSize,
      Width: thumbSize
    };

    return Cx.Core.Doc3D.thumbnailUrl(requestModel);
  }

  return <div className={props.className || ''}>
    {
      orders.length > 0
        ?
        <React.Fragment>
          <div className={[styles.orderItemHeader].join(' ')}>
            <div className={[styles.thumbListPreview].join(' ')}></div>
            <div className={[styles.header, styles.column].join(' ')}>ITEMS</div>
            <div className={[styles.header, styles.column].join(' ')}>PRODUCTS</div>
            <div className={[styles.header, styles.column].join(' ')}>ROSTER</div>
            <div className={[styles.header, styles.column].join(' ')}>LAST UPDATED</div>
          </div>
          {orders.map((savedOrder: SavedOrder) => {
            const date = formatDate(savedOrder.lastUpdatedOn);
            const columnData = getColumnData(savedOrder);
            const products = columnData?.products;
            const onClick = () => props.onOrderClick(savedOrder);

            return <div className={styles.orderItem} key={savedOrder.id} onClick={onClick} style={{ display: checkInvalidId(savedOrder.id) }}>
              <div className={styles.thumbListPreview}>
                {products && products.map(function (product: any, index: number) {
                  return <>
                    <img
                      id={savedOrder.orderState[index].Id + "_" + String(index)}
                      src={getDocThumb(savedOrder.orderState[index].GrayGood.DocId)}
                      className={[styles.imageColumn, styles.blur].join(' ')} />
                    <img
                      ref={el => img.current[index] = el}
                      onError={(e) => hideDivById(savedOrder.id)}
                      key={uniqueId()}
                      onLoad={(e) => handleOnLoad(e, savedOrder.orderState[index].Id + "_" + String(index))}
                      className={[styles.imageColumn, styles.fadeIn].join(' ')}
                      src={getValidThumbUrl({
                        Size: 100,
                        Camera: 'Front',
                        DocId: product.savedDocId,
                        cadworxSessionId: props.cadworxSessionId,
                        type: "img"
                      }, savedOrder.orderState[index])} alt="front"
                      style={{ display: "none" }} />
                  </>
                })}
              </div>
              <div className={styles.column}>
                <span className={styles.mobileHeader}>ITEMS</span>
                {columnData.productCount}
              </div>
              <div className={[styles.column, styles.flexColumn].join(' ')}>
                <span className={styles.mobileHeader}>PRODUCTS</span>
                {columnData.productList &&
                  columnData.productList.map((name: any) => {
                    return <span key={uniqueId()}>{name}</span>
                  })}
              </div>
              <div className={[styles.column, styles.flexColumn].join(' ')}>
                <span className={styles.mobileHeader}>ROSTER</span>
                {columnData.rosterList &&
                  columnData.rosterList.map((hasRoster: any) => {
                    return hasRoster ? <i key={uniqueId()} className="icon fas fa-solid fa-check"></i> : <i key={uniqueId()} className="icon fas fa-solid fa-times"></i>
                  })}
              </div>
              <div className={styles.column}>
                <span className={styles.mobileHeader}>LAST UPDATED</span>
                {date}
              </div>
            </div>
          })}
        </React.Fragment>
        :
        <div className={styles.noItemsFound}>No items found...</div>
    }
  </div>
}

function getColumnData(order: SavedOrder) {
  const orderSnippet: any = Cx.cloneDeep(order.orderStateSnippet) || [];
  let productList: any = [];
  let rosterList: any = [];
  let total = 0;

  orderSnippet?.products?.forEach((p, i) => {
    if (p.total)
      Cx.warning('total property on order snippet no longer supported.');

    productList.push(p.grayGoodName);
    const hasRosters = order.orderState[i].RosterItems.length > 0;
    rosterList.push(hasRosters);
    total += p.totalPrice;
  });

  return {
    productList,
    rosterList,
    rosterTotal: order.orderState.map(s => s.RosterItems.length),
    products: orderSnippet?.products,
    productCount: orderSnippet?.products?.length,
    total
  };
}

export default SavedOrdersSummary;
